import LegalPage from "../components/LegalPage";

export default function ShippingInformation() {
  return (
    <LegalPage
      eyebrow="Customer Service"
      title="Shipping Information"
      summary="How orders ship out of our U.S. warehouse, holiday closures, modifications, and the return window."
      sections={[
        {
          id: "timeline",
          title: "Shipping Timeline",
          body:
            "All orders ship within 1–3 business days. Business hours are Monday–Friday, 9:00am–5:00pm Mountain Time, with no weekend processing. Orders placed Friday before 11:00am qualify for next-business-day delivery via overnight service. Large orders exceeding 10 items may take longer to process. Once a package leaves the warehouse, carrier delays are between you and UPS / FedEx / USPS.",
        },
        {
          id: "holidays",
          title: "Holiday Closures",
          list: [
            "New Year's Day",
            "Memorial Day",
            "Independence Day",
            "Labor Day",
            "Thanksgiving (two days)",
            "Christmas Day",
          ],
        },
        {
          id: "warehouse",
          title: "Warehouse & Geography",
          body:
            "Mystery Ranch operates one warehouse in the United States, located in Washington. All domestic shipments originate there. We do not service international orders directly — please consult our international distributor network for shipments outside the U.S.",
        },
        {
          id: "modifications",
          title: "Order Modifications",
          body:
            "Post-purchase changes require immediate customer service contact. Whether a change is possible depends on processing stage. A $25.00 fee will be added to any order rerouted after it has shipped.",
        },
        {
          id: "returns",
          title: "Return Policy",
          body:
            "Returns are accepted for refund within 60 days of package delivery. Items must be unused and in original condition. Shipping fees are non-refundable. For damaged or defective goods, contact the warranty department instead of using the standard returns process.",
        },
        {
          id: "links",
          title: "Resources",
          links: [
            { label: "Returns portal",    href: "/contact",   note: "start a return request" },
            { label: "Warranty / repair", href: "/contact" },
            { label: "Contact us",        href: "/contact" },
          ],
        },
      ]}
    />
  );
}
